import * as Yup from 'yup';

export const ContactsToggleSchema = Yup.object().shape({
  autosave: Yup.boolean(),
});

export interface ContactsToggleDataType {
  autosave: boolean;
}

export const ContactsToggleInitialValues: ContactsToggleDataType = {
  autosave: false,
};

export interface ContactsToggleInterface {
  autosave: boolean;
}
